// Test script to verify Amplify Auth credential management
import { CredentialManager } from './CredentialManager';

export async function testCredentialManager() {
  try {
    console.log('Testing Amplify Auth credential manager...');
    
    const credManager = new CredentialManager();
    const credentials = await credManager.getCredentials();
    
    console.log('✅ Credentials retrieved successfully:', {
      accessKeyId: credentials.accessKeyId?.substring(0, 10) + '...',
      hasSecretKey: !!credentials.secretAccessKey,
      hasSessionToken: !!credentials.sessionToken,
      expiration: credentials.expiration,
      region: credentials.region
    });
    
    return credentials;
  } catch (error) {
    console.error('❌ Credential manager test failed:', error);
    throw error;
  }
}